export default interface CouponsEntity {
    _id?: string,
    code?: string,
    type: TypesCoupon
    discount?: number,
    amount?: number,
    expiration: Date,
}

export enum TypesCoupon {
    AMOUNT = 'amount',
    DISCOUNT = 'discount'
}